import HttpClient from '../HttpService';

function getById(uuid) {
	return HttpClient.get(`/forms/${uuid}`);
}

function create(data) {
	return HttpClient.post('/forms', { form: data });
}

function update(data) {
	return HttpClient.put(`/forms/${data.uuid}`, { form: data });
}

function destroy(uuid) {
	return HttpClient.delete(`/forms/${uuid}`);
}

function list(page, limit, filter = {}) {
	return HttpClient.post(`/forms/list?page=${page}&limit=${limit}`, filter);
}

export default {
	getById,
	create,
	update,
	destroy,
	list
};